export class CancelledByUser extends Error {
  cancelledByUser = true;

  constructor() {
    super("Cancelled by user");
  }
}
